import { ConverterType } from '../domain';
export const float = {
    types: [
        'FLOAT',
        'DOUBLE',
        'google.protobuf.FloatValue',
        'google.protobuf.DoubleValue',
    ],
    [ConverterType.TO_JSON]: {
        transform: (val) => {
            return isFinite(val) ? val : val.toString();
        },
    },
    [ConverterType.FROM_JSON]: {
        transform: (val) => {
            if (val === 'NaN') {
                return NaN;
            }
            if (val === 'Infinity') {
                return Infinity;
            }
            if (val === '-Infinity') {
                return -Infinity;
            }
            return val;
        },
    },
};
//# sourceMappingURL=float.js.map